import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { configs } from '@hero/configs';
import { ROUTE_PATHS } from '@hero/routes';

import * as S from './style';

function InviteFinish({ authInfo }) {
  const { t } = useTranslation();

  return (
    <S.InviteFinish>
      <S.InviteFinishCard>
        <S.InviteFinishCardSuccess>
          <Icon name="success" size="xxl" color="var(--color-success-default)" />
        </S.InviteFinishCardSuccess>
        <Typography>{t('InviteFinish.message')}</Typography>
        <a
          href={`${configs.publicUrl}${ROUTE_PATHS.LOGIN(authInfo.token, authInfo.organizationCode)}`}
        >
          <Button type="button">{t('goToDashboard')}</Button>
        </a>
      </S.InviteFinishCard>
    </S.InviteFinish>
  );
}

export { InviteFinish };

InviteFinish.propTypes = {
  authInfo: PropTypes.shape({
    token: PropTypes.string,
    organizationCode: PropTypes.string
  }).isRequired
};
